import { FC } from 'react';
import { SingleValueProps, GroupBase, components } from 'react-select';
import { getIconByAsset } from '@/helpers';
import { AppImage, Skeleton } from '@/components';
import { PaymentSelectOption } from '../models';

import styles from './SimpleSingleValueChain.module.sass';

const { SingleValue } = components;

export type SingleValueChainProps = SingleValueProps<
  PaymentSelectOption,
  false,
  GroupBase<PaymentSelectOption>
>;

const SimpleSingleValueChain: FC<SingleValueChainProps> = (props) => {
  const { children, ...restProps } = props;
  const { data } = restProps;
  const { label, value, discount } = data;

  const iconSrc = getIconByAsset(value);

  return (
    <SingleValue {...restProps}>
      <div className={styles.single}>
        <div className={styles.icon}>
          <AppImage
            src={iconSrc}
            alt={label}
            fallback={<Skeleton className={styles.icon} border="50%" />}
          />
        </div>
        <div className={styles.info}>
          <div className={styles.label}>{label}</div>
        </div>
        {!!discount && <div className={styles.discount}>-{discount}%</div>}
      </div>
    </SingleValue>
  );
};

export default SimpleSingleValueChain;
